import { withControlledField } from '../ControlledField';
import { ToggleableTextFieldWrapper } from './ToggleableTextFieldWrapper';

export const ControlledToggleableTextField = withControlledField(
  ToggleableTextFieldWrapper,
);
